export default __webpack_public_path__ + "static/posterBanner-fcf06a0a72663d534e7d52f2d1a74a88.png";